import * as React from "react"

function NumberIcon(props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={16}
      height={16}
      viewBox="0 0 24 24"
      fill="none"
      {...props}
    >
      <path
        d="M4 9h16M4 15h16M10 3L8 21m8-18l-2 18"
        stroke="#545454"
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

export default NumberIcon
